export const isProduction = process.env.NODE_ENV === 'production';

const clientConfig = {
    baseUrl: isProduction ? 'https://www.mploy.co.il/' : 'http://localhost:3000/',
};

export default clientConfig;
